import { Component, OnInit } from '@angular/core';
import { BucketService } from 'app/dashboard/buckets/bucket.service';
import { UiColors, UiThemes } from 'app/interfaces/ui.interfaces';
import { ButtonTypes } from 'app/shared/buttons/basic-button.component';
import { IconTypes } from 'app/shared/icon/icon.interfaces';
import { ModalSizes, ModalAction } from 'app/shared/modals/modal.interfaces';
import { SimpleModalComponent } from 'ngx-simple-modal';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-bucket-settings',
  templateUrl: './bucket-settings.component.html',
  styleUrls: ['./bucket-settings.component.scss']
})
export class BucketSettingsComponent extends SimpleModalComponent<any, any> implements OnInit {

  public ModalSizes = ModalSizes;
  public IconTypes = IconTypes;
  public UiColors = UiColors;
  public UiThemes = UiThemes;
  public ButtonTypes = ButtonTypes;
  public actions: ModalAction[] = [
    { name: 'cancel', title: 'Cancel' },
    { name: 'confirm', title: 'Confirm', isPrimary: true },
  ];

  deleteOption: boolean = false;

  constructor(public bucketService: BucketService) {
    super();
  }

  ngOnInit(): void {

    this.bucketService.deleteBucketEnabled$.subscribe(value => {
      this.deleteOption = value ?? false;
    })
  }

  handleAction($event): void {
    if ($event === 'cancel') {
      this.close();
    }
    if ($event === 'confirm') {
      this.bucketService.setBucketDeleteSetting(this.deleteOption);
      this.close();
    }
  }

  changeValue(option: boolean): void {
    this.deleteOption = !option;
  }
}
